/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TopListener
 */
export interface TopListener {
    /**
     * 
     * @type {Array<TopListener>}
     * @memberof TopListener
     */
    data?: Array<TopListener>;
}

/**
 * Check if a given object implements the TopListener interface.
 */
export function instanceOfTopListener(value: object): value is TopListener {
    let isInstance = true;

    return isInstance;
}

export function TopListenerFromJSON(json: any): TopListener {
    return TopListenerFromJSONTyped(json, false);
}

export function TopListenerFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopListener {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(TopListenerFromJSON)),
    };
}

export function TopListenerToJSON(value?: TopListener | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(TopListenerToJSON)),
    };
}

